export default "/kiban/_next/static/images/24_8L_2-4-2_withoutBH_stack-6c6751f7dbde0a57f1768e966a442feb.png";